import { registerPlugin } from "@capacitor/core";

export interface TimerPluginInterface {
  startActivity(options: { id: string; label: string; remaining: number }): Promise<{ started: boolean; reason?: string }>;
  pauseActivity(options: { id: string; remaining: number }): Promise<void>;
  endActivity(options: { id: string }): Promise<void>;
}

// Web stub — Live Activities are iOS-only. All calls are silent no-ops on web.
const webStub: TimerPluginInterface = {
  startActivity: async () => ({ started: false }),
  pauseActivity: async () => {},
  endActivity:   async () => {},
};

export const TimerNativePlugin = registerPlugin<TimerPluginInterface>("TimerPlugin", {
  web: () => webStub,
});
